import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditMeter = ({meterId, list}) => {
    const [meterData, setMeterData] = useState(null);

    const fetchMeter = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/meter/${Id}`)
            .then(response => {
                setMeterData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setMeterData([]); 
            });
    }

    useEffect(() => {
        if (meterId) {
            fetchMeter(meterId);
        }
    },[meterId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
        upwork_name: Yup.string().required('upwork name is a required field'),
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (meterData) {
            reset(meterData);
        }
    }, [meterData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/meter/${meterId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_meter_${meterId}`);
                list();
            })
            .catch(error => {
                Swal.fire({text:error, icon:"error"});
            });
    }

    if (!meterId || !meterData) {
        return null;
    }

    return (
        <div id={`edit_meter_${meterId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Meter</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Meter Name <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={meterData.name} {...register('name')}/>
                                        <div className="text-sm text-danger">
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Upwork Name <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={meterData.upwork_name} {...register('upwork_name')}/>
                                        <div className="text-sm text-danger">
                                            {errors.upwork_name && <p>{errors.upwork_name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditMeter
